import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let lenis;

const handleDarkmode = (e) => {
  var darkModeOn = e.matches;
  var largeFavicons = document.querySelectorAll('link[rel="icon"]');
  if (!largeFavicons) {
    return;
  }
  if (darkModeOn) {
    largeFavicons.forEach(ele => {
      ele.href = require("./src/assets/images/favicon-light-mode.svg").default
    })
  } else {
    largeFavicons.forEach(ele => {
      ele.href = require("./src/assets/images/favicon-dark-mode.svg").default
    })
  }
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  // Darkmode favicon handling
  if (typeof window !== "undefined") {
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    darkModeMediaQuery.addListener(e => {
      handleDarkmode(darkModeMediaQuery)
    })
    handleDarkmode(darkModeMediaQuery)

    const urlParams = new URLSearchParams(location.search);
    const utmParams = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
    let foundParams = {};

    utmParams.forEach(param => {
      const value = urlParams.get(param);
      if (value) {
        foundParams[param] = value;
      }
    });

    if (Object.keys(foundParams).length > 0) {
      sessionStorage.setItem("utmParams", JSON.stringify(foundParams));
    }
  }

  // Lenis smooth scrolling
  if (lenis) {
    lenis.destroy();
  }
  lenis = new Lenis();
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);

  const hash = window.gatsby_router_hash;
  const scrollToHash = () => {
    const scrollOffset = -100;
    const element = document.getElementById(hash?.substr(1));
    if (element) {
      const top = element.getBoundingClientRect().top + window.scrollY + scrollOffset;
      lenis.scrollTo(top, { immediate: true });
    }
  };

  if (hash) {
    if (prevLocation?.pathname === location.pathname) {
      scrollToHash();
    } else {
      setTimeout(scrollToHash, 300);
    }
    window.gatsby_router_hash = undefined;
  }

  ScrollTrigger.refresh();
};

export const onPreRouteUpdate = () => {
  if (lenis) {
    lenis.destroy();
    gsap.ticker.remove(() => {});
    lenis = null;
  }
};

/*
* If the pathnames are the same, and there is a router hash, don't use in-built page scroll updating
*/
export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => !(prevRouterProps?.location?.pathname
    === routerProps?.location?.pathname && window.gatsby_router_hash);
